import { defineComponent as _defineComponent } from 'vue'
import router from '@/router'
import { ref, withDefaults } from 'vue'

interface Props {
  visible: boolean
  repeatNameList: Array<any>
  repeatFileNameList: Array<any>
  repeatFolderNameList: Array<any>
}

export default /*#__PURE__*/_defineComponent({
  __name: 'g-warning-modal',
  props: {
    visible: { type: Boolean, default: false },
    repeatNameList: { default: () => [] },
    repeatFileNameList: { default: () => [] },
    repeatFolderNameList: { default: () => [] }
  },
  emits: ['update:visible'],
  setup(__props: any, { emit: emits }) {



let isShowMoreRepeat = ref(false) //查看所有重名文件
function handleCancel() {
  emits('update:visible', false)
  isShowMoreRepeat.value = false
}
function handleToFileManage() {
  router.push('/fileManage')
}

return { __sfc: true,emits, isShowMoreRepeat, handleCancel, handleToFileManage }
}

})